(function(){
    'use strict'

    angular
    .module('app.procesosMasivos')
    .controller('ProcesarMasivo', ProcesarMasivo);

    ProcesarMasivo.$inject = ['$scope', '$animationsSrv', 'ProcesosMasivosService', 'TiposPlanillaService', 'PuestosService', 'DepartamentosService', 'EmpleadosService', 'logger', '$location', 'UserInfoService', 'moment', 'BloqueoXUsuarioService'];

    function ProcesarMasivo($scope, $animationsSrv, ProcesosMasivosService, TiposPlanillaService, PuestosService, DepartamentosService, EmpleadosService, logger, $location, UserInfoService, moment, BloqueoXUsuarioService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        var searchKey = "Procesar_Masivo_Search_Criteria";

        vm.tiposPlanilla = [];
        vm.puestos = [];
        vm.departamentos = [];
        vm.tiposProceso = [];
        vm.empleados = [];

        vm.procesarMasivo = {
            tipoPlanillaId: -1,
            empleadoDepartamento: -1,
            empleadoPuesto: -1,
            tipoProceso: -1,
            empleadoNombre: '',
            empleadoIdentificacion: '',
            esPorcentaje: false,
            monto: 0,
            companiaId: UserInfoService.getCompaniaId()
        };

        vm.title = 'Procesar Masivo';

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.goToProcesosMasivosDetalle = function(procesoId){
            
            var path = '/proceso-masivo-detalle/';

            if(procesoId){
                $location.path(path + UserInfoService.getCompaniaId() + '/' + procesoId);
            }
            else{
                logger.error('No fue posible cargar los datos del proceso');
            }
            
        };

        var promiseTipoPlanilla = getTiposPlanilla();
        var promisePuestos = getPuesto();
        var promiseDepartamento = getDepartamento();
        getTiposProceso();

        CargarPreviousSearch();

        function CargarPreviousSearch(){
            var previousSearch = UserInfoService.getDataFromSessionStorage(searchKey);
            if(previousSearch){
                vm.procesarMasivo = previousSearch;
                $q.all([promiseTipoPlanilla, promisePuestos, promiseDepartamento]).then(function(){

                    console.log('Datos Iniciales Cargados');
                    //vm.search();
                });               
            }

        };

        function getTiposProceso(){
            var promise = ProcesosMasivosService.getTipos()
            .then(function(tiposProceso){
                vm.tiposProceso = tiposProceso;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de procesos.');
            }); 
            
            return promise;
        };

        vm.tipoProcesoChange = function(){
            validateTipo();
        };

        function validateTipo(){
            if(vm.procesarMasivo.tipoProceso == -1){
                $scope.procesarMasivoForm.tipoProceso.$setValidity("different", false);
            }
            else{
                $scope.procesarMasivoForm.tipoProceso.$setValidity("different", true);
            }
        }

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getPuesto(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getDepartamento(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los departamentos.');
            }); 
            
            return promise;
        };

        function doFormValidations(){
            validateTipo();
        };

        vm.procesar = function() {

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.procesarMasivoForm.$valid)
            {
                return;
            }

            var promise = ProcesosMasivosService.procesar(vm.procesarMasivo);
                
            promise
            .then(function(response){
                logger.success('Proceso ejecutado con éxito.');
                vm.goToProcesosMasivosDetalle(response.data.id);
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un error al ejecutar el proceso: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al procesar la planilla');
                        break;
                }
            }); 
        };
        
        vm.search = function(){

            var criteriosBusqueda = {
                companiaId: vm.procesarMasivo.companiaId,
                nombre: vm.procesarMasivo.empleadoNombre,
                identificacion: vm.procesarMasivo.empleadoIdentificacion,
                departamentoId: vm.procesarMasivo.empleadoDepartamento,
                puestoId: vm.procesarMasivo.empleadoPuesto,
                tipoPlanillaId: vm.procesarMasivo.tipoPlanillaId,
                estado: 'S'
            };

            var promise = EmpleadosService.getAll(criteriosBusqueda);

            promise
            .then(function(result){
                vm.empleados = result.data;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los empleados.');
                        break;
                }
            });
        };

        vm.limpiar = function(){
            vm.procesarMasivo = {
                tipoPlanillaId: -1,
                empleadoDepartamento: -1,
                empleadoPuesto: -1,
                tipoProceso: -1,
                empleadoNombre: '',
                empleadoIdentificacion: '',
                esPorcentaje: false,
                monto: 0,
                companiaId: UserInfoService.getCompaniaId()
            };
        };

    }
})();